import styled from 'styled-components';

import COLORS from '@ui-component-library/styles/colors';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div`
    width: 100%;
  `,

  Header: styled.div`
    border: 1px solid ${COLORS['stone-300']};
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    padding: ${SPACING.size16};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,

  Content: styled.div``,

  Footer: styled.div`
    border: 1px solid ${COLORS['stone-300']};
    border-top-width: 0;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    padding-top: ${SPACING.size8};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: ${SPACING.size12};
    padding: ${SPACING.size16} ${SPACING.size8};

    &:hover {
      background-color: ${COLORS['stone-50']};
    }
  `
};
